"use strict";
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionLog = exports.LogType = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const customer_entity_1 = require("./customer.entity");
const user_entity_1 = require("../users/user.entity");
var LogType;
(function (LogType) {
    LogType["INBOUND_CALL"] = "inbound_call";
    LogType["OUTBOUND_CALL"] = "outbound_call";
    LogType["WHATSAPP_SENT"] = "whatsapp_sent";
    LogType["WHATSAPP_INBOUND"] = "whatsapp_inbound";
    LogType["SMS_SENT"] = "sms_sent";
    LogType["SMS_RECEIVED"] = "sms_received";
    LogType["EMAIL_SENT"] = "email_sent";
    LogType["ORDER_CREATED"] = "order_created";
    LogType["TICKET_CREATED"] = "ticket_created";
    LogType["NOTE"] = "note";
    LogType["FEEDBACK"] = "feedback";
    LogType["APPOINTMENT"] = "appointment";
})(LogType || (exports.LogType = LogType = {}));
let InteractionLog = class InteractionLog {
};
exports.InteractionLog = InteractionLog;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], InteractionLog.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => customer_entity_1.Customer, (c) => c.interactionLogs, { onDelete: 'CASCADE' }),
    tslib_1.__metadata("design:type", typeof (_a = typeof customer_entity_1.Customer !== "undefined" && customer_entity_1.Customer) === "function" ? _a : Object)
], InteractionLog.prototype, "customer", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => user_entity_1.User, { nullable: true, eager: true }),
    tslib_1.__metadata("design:type", typeof (_b = typeof user_entity_1.User !== "undefined" && user_entity_1.User) === "function" ? _b : Object)
], InteractionLog.prototype, "agent", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'enum', enum: LogType }),
    tslib_1.__metadata("design:type", String)
], InteractionLog.prototype, "type", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ type: 'text' }),
    tslib_1.__metadata("design:type", String)
], InteractionLog.prototype, "description", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], InteractionLog.prototype, "relatedEntityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ length: 60, nullable: true }),
    tslib_1.__metadata("design:type", String)
], InteractionLog.prototype, "relatedEntityType", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ nullable: true }),
    tslib_1.__metadata("design:type", Number)
], InteractionLog.prototype, "callDurationSeconds", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)(),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], InteractionLog.prototype, "createdAt", void 0);
exports.InteractionLog = InteractionLog = tslib_1.__decorate([
    (0, typeorm_1.Entity)('interaction_logs')
], InteractionLog);
